var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralType = function SvgGeneralType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 56,
    fill: "none",
    viewBox: "0 0 87 74"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.92 8.914 5.362 19.76a4.98 4.98 0 0 0-2.542 6.565l18.312 41.461a4.98 4.98 0 0 0 6.565 2.542l24.558-10.846a4.98 4.98 0 0 0 2.542-6.565L36.484 11.456a4.98 4.98 0 0 0-6.564-2.542"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "M25.695 70.988a5.22 5.22 0 0 1-4.776-3.107L2.605 26.42a5.18 5.18 0 0 1-.093-3.99 5.18 5.18 0 0 1 2.756-2.887L29.826 8.695a5.18 5.18 0 0 1 3.99-.092 5.18 5.18 0 0 1 2.887 2.755L55.017 52.82a5.18 5.18 0 0 1 .093 3.99 5.18 5.18 0 0 1-2.756 2.887L27.795 70.544a5.2 5.2 0 0 1-2.1.444m6.236-62.266c-.65 0-1.3.135-1.914.407L5.458 19.978a4.7 4.7 0 0 0-2.505 2.624 4.7 4.7 0 0 0 .084 3.627l18.314 41.46a4.745 4.745 0 0 0 6.252 2.421L52.16 59.262a4.7 4.7 0 0 0 2.505-2.624 4.7 4.7 0 0 0-.084-3.628L36.268 11.55a4.7 4.7 0 0 0-2.624-2.505 4.8 4.8 0 0 0-1.713-.322z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M25.695 70.988a5.22 5.22 0 0 1-4.776-3.107L2.605 26.42a5.18 5.18 0 0 1-.093-3.99 5.18 5.18 0 0 1 2.756-2.887L29.826 8.695a5.18 5.18 0 0 1 3.99-.092 5.18 5.18 0 0 1 2.887 2.755L55.017 52.82a5.18 5.18 0 0 1 .093 3.99 5.18 5.18 0 0 1-2.756 2.887L27.795 70.544a5.2 5.2 0 0 1-2.1.444m6.236-62.266c-.65 0-1.3.135-1.914.407L5.458 19.978a4.7 4.7 0 0 0-2.505 2.624 4.7 4.7 0 0 0 .084 3.627l18.314 41.46a4.745 4.745 0 0 0 6.252 2.421L52.16 59.262a4.7 4.7 0 0 0 2.505-2.624 4.7 4.7 0 0 0-.084-3.628L36.268 11.55a4.7 4.7 0 0 0-2.624-2.505 4.8 4.8 0 0 0-1.713-.322z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M25.695 70.988a5.22 5.22 0 0 1-4.776-3.107L2.605 26.42a5.18 5.18 0 0 1-.093-3.99 5.18 5.18 0 0 1 2.756-2.887L29.826 8.695a5.18 5.18 0 0 1 3.99-.092 5.18 5.18 0 0 1 2.887 2.755L55.017 52.82a5.18 5.18 0 0 1 .093 3.99 5.18 5.18 0 0 1-2.756 2.887L27.795 70.544a5.2 5.2 0 0 1-2.1.444m6.236-62.266c-.65 0-1.3.135-1.914.407L5.458 19.978a4.7 4.7 0 0 0-2.505 2.624 4.7 4.7 0 0 0 .084 3.627l18.314 41.46a4.745 4.745 0 0 0 6.252 2.421L52.16 59.262a4.7 4.7 0 0 0 2.505-2.624 4.7 4.7 0 0 0-.084-3.628L36.268 11.55a4.7 4.7 0 0 0-2.624-2.505 4.8 4.8 0 0 0-1.713-.322z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "m29.42 15.364-18.956 8.373a2.757 2.757 0 0 0-1.408 3.635v.001a2.757 2.757 0 0 0 3.636 1.408L31.65 20.41a2.757 2.757 0 1 0-2.228-5.044"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m29.42 15.364-18.956 8.373a2.757 2.757 0 0 0-1.408 3.635v.001a2.757 2.757 0 0 0 3.636 1.408L31.65 20.41a2.757 2.757 0 1 0-2.228-5.044"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m29.42 15.364-18.956 8.373a2.757 2.757 0 0 0-1.408 3.635v.001a2.757 2.757 0 0 0 3.636 1.408L31.65 20.41a2.757 2.757 0 1 0-2.228-5.044"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "m36.432 24.656-23.82 10.52a.828.828 0 1 0 .668 1.514L37.1 26.169a.827.827 0 1 0-.668-1.513"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m36.432 24.656-23.82 10.52a.828.828 0 1 0 .668 1.514L37.1 26.169a.827.827 0 1 0-.668-1.513"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m36.432 24.656-23.82 10.52a.828.828 0 1 0 .668 1.514L37.1 26.169a.827.827 0 1 0-.668-1.513"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "m39.09 30.675-23.82 10.52a.827.827 0 1 0 .67 1.514l23.82-10.52a.827.827 0 1 0-.67-1.514"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m39.09 30.675-23.82 10.52a.827.827 0 1 0 .67 1.514l23.82-10.52a.827.827 0 1 0-.67-1.514"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m39.09 30.675-23.82 10.52a.827.827 0 1 0 .67 1.514l23.82-10.52a.827.827 0 1 0-.67-1.514"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "m41.749 36.697-23.82 10.52a.828.828 0 1 0 .669 1.514l23.82-10.521a.828.828 0 1 0-.669-1.513"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m41.749 36.697-23.82 10.52a.828.828 0 1 0 .669 1.514l23.82-10.521a.828.828 0 1 0-.669-1.513"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m41.749 36.697-23.82 10.52a.828.828 0 1 0 .669 1.514l23.82-10.521a.828.828 0 1 0-.669-1.513"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "m44.41 42.716-23.82 10.52a.827.827 0 1 0 .668 1.514l23.82-10.52a.828.828 0 1 0-.669-1.514"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m44.41 42.716-23.82 10.52a.827.827 0 1 0 .668 1.514l23.82-10.52a.828.828 0 1 0-.669-1.514"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m44.41 42.716-23.82 10.52a.827.827 0 1 0 .668 1.514l23.82-10.52a.828.828 0 1 0-.669-1.514"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "m47.157 48.698-18.501 8.171a.73.73 0 0 0-.374.966l.077.174c.163.37.596.537.965.374l18.501-8.172a.73.73 0 0 0 .374-.965l-.077-.174a.73.73 0 0 0-.965-.374"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m47.157 48.698-18.501 8.171a.73.73 0 0 0-.374.966l.077.174c.163.37.596.537.965.374l18.501-8.172a.73.73 0 0 0 .374-.965l-.077-.174a.73.73 0 0 0-.965-.374"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m47.157 48.698-18.501 8.171a.73.73 0 0 0-.374.966l.077.174c.163.37.596.537.965.374l18.501-8.172a.73.73 0 0 0 .374-.965l-.077-.174a.73.73 0 0 0-.965-.374"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEECF9",
    d: "M80.427.56H44.973A6.57 6.57 0 0 0 38.4 7.134v59.855a6.57 6.57 0 0 0 6.573 6.573h35.454A6.57 6.57 0 0 0 87 66.988V7.133A6.57 6.57 0 0 0 80.427.561"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.382 8.086H49.017a3.641 3.641 0 1 0 0 7.282h27.365a3.641 3.641 0 1 0 0-7.282M79.893 23.049H45.506a1.093 1.093 0 1 0 0 2.185h34.387a1.093 1.093 0 1 0 0-2.185M79.893 31.74H45.506a1.093 1.093 0 1 0 0 2.185h34.387a1.093 1.093 0 1 0 0-2.185M79.893 40.432H45.506a1.093 1.093 0 1 0 0 2.185h34.387a1.093 1.093 0 1 0 0-2.185M79.893 49.123H45.506a1.093 1.093 0 1 0 0 2.185h34.387a1.093 1.093 0 1 0 0-2.185M80.018 57.815H53.311a.967.967 0 0 0-.967.966v.251c0 .534.433.967.967.967h26.707a.967.967 0 0 0 .967-.967v-.25a.967.967 0 0 0-.967-.967"
  })));
};
export default SvgGeneralType;